import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import app from "./reducers";
import { historyMiddleware } from "./Middlewares/History.middleware";
import MiniCartContainer from "./Containers/MiniCart.container";
import SearchContainer from "./Containers/Search.container";
import QuickSearchContainer from "./Containers/QuickSearch.container";
import NavigationContainer from "./Containers/Navigation.container";
import FacetedSearchContainer from "./Containers/FacetedSearch.container";
import FacetedSearchCompactContainer from "./Containers/FacetedSearchCompact.container";
import RecipeFilterContainer from "./Containers/RecipeFilter.container";
import RecipeFilterCompactContainer from "./Containers/RecipeFilterCompact.container";
import NotificationContainer from "./Containers/Notification.container";
import DynamicComponent from "./Components/DynamicComponent";
import AOS from "aos";
import { tcEventProductClickEvent } from "./Actions/TagCommander.action";
import { getCookie, setCookie } from "./Services/cookies";
import { translate } from './Services/translation';

const decode = (encodedHtml) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = encodedHtml;
  return txt.value;
}

window.HandleUcrLoginLogin = function (username, password) {
  fetch(`/customErpApi/Login/Login?username=${username}&password=${password}`)
    .then((res) => {
      res.ok && window.location.reload();
    })
    .catch((err) => console.warn("LoginError", err));
};

const mobileBreakpoint = 768;
const tabletBreakpoint = 1024;

// For Iframed Login - Successfull Iframe redirect emits postmessage event to parent window
window.addEventListener("message", function (message) {
  const { data } = message;
  if (
    data.eventId == "salesforce_accountDeleted" ||
    data.eventId == "salesforce_emailChanged" ||
    data.eventId == "salesforce_passwordChanged"
  ) {
    var logoutButton = document.querySelector("[data-logout-button] > a");
    if (logoutButton) {
      window.location.href = logoutButton.href;
    }
  }
});

AOS.init({
  once: true,
});

window.addEventListener("load", AOS.refresh);

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = (window.__litium.store =
  window.__litium.store ||
  (window.parent.__litium && window.parent.__litium.store) ||
  createStore(
    app,
    preloadState,
    composeWithDevTools(applyMiddleware(thunk, historyMiddleware))
  ));
window.__litium = {
  ...window.__litium,
  bootstrapComponents: () => {
    // bootstrap React components, in case the HTML response we receive from the server
    // has React components. ReactDOM.render performs only an update on previous rendered
    // components and only mutate the DOM as necessary to reflect latest React element.
    bootstrapComponents();
  },
  bootstrapSearchResultFilterProductList: () => {
    // When a filter reloads the product list, it previusly called bootstrapComponents, which
    // resulted in all components being re-rendered and caused a lot of work and rerenders.
    // This is specifically called from the FacetedSearchCompact.container.js, and only 
    // re-renders the product list components.
    bootstrapSearchResultFilterProductList();
  },
  cache: {}, // for storing cache data for current request
};

if (document.querySelector("[small-breadcrumbs-container]")) {
  // Select the first block if it has the small-breadcrumbs-container attribute, only supported by hero-banner as of now
  const smallContainer = document.querySelector(
    "main > :first-child [small-breadcrumbs-container]"
  );
  const normalContainer = document.querySelector(".breadcrumbs-container");
  const breadcrumbs = document.querySelector(".breadcrumbs");
  const isTablet = window.innerWidth <= tabletBreakpoint;

  if (smallContainer && normalContainer && breadcrumbs) {
    const moveToSmall = () =>
      !smallContainer.contains(breadcrumbs) &&
      smallContainer.appendChild(breadcrumbs);
    const moveToNormal = () =>
      !normalContainer.contains(breadcrumbs) &&
      normalContainer.appendChild(breadcrumbs);

    // Initial check
    isTablet ? moveToSmall() : moveToNormal();

    window.addEventListener("resize", () =>
      window.innerWidth <= tabletBreakpoint ? moveToSmall() : moveToNormal()
    );
  }
}

if (document.querySelectorAll("[share-button]").length > 0) {
  document.querySelectorAll("[share-button]").forEach((button) => {
    const url = window.location.href;
    const data = {
      title: button.getAttribute("share-title") || null,
      text: button.getAttribute("share-text") || "",
      url: url,
    };

    if (data.title == null) {
      CopyToClipboard();
      return;
    }

    button.addEventListener("click", async () => {
      if (navigator.share) {
        navigator
          .share(data)
          .catch((error) => console.log("Error sharing object:", data, error));
      } else CopyToClipboard();
    });

    function CopyToClipboard() {
      // fallback to copy to clipboard
      navigator.clipboard.writeText(url);
    }
  });
}

if (document.querySelectorAll('button[role="tab"]').length > 0) {
  const tabElements = document.querySelectorAll('button[role="tab"]');
  const panelElements = document.querySelectorAll('[role="tabpanel"]');
  let activeIndex = 0;

  tabElements.forEach(function (tab, index) {
    tab.addEventListener("click", function (event) {
      setActiveTab(index);
    });
  });

  function setActiveTab(index) {
    // Make currently active tab inactive
    tabElements[activeIndex].setAttribute("aria-selected", "false");
    // Set the new tab as active
    tabElements[index].setAttribute("aria-selected", "true");

    setActivePanel(index);
    activeIndex = index;
  }

  function setActivePanel(index) {
    // Hide currently active panel
    panelElements[activeIndex].setAttribute("hidden", "");
    // Show the new active panel
    panelElements[index].removeAttribute("hidden");
  }
}

if (document.querySelectorAll('.marketing-article').length > 0) {
  document.querySelectorAll('.marketing-article').forEach((marketingArticleBlock) => {
    const showMoreLimit = marketingArticleBlock.dataset.showMoreLimit;
    const shouldShowMore = marketingArticleBlock.dataset.shouldShowMore == "True";
    
    if (!shouldShowMore) 
      return;

    const itemsArr = [...marketingArticleBlock.querySelectorAll('.marketing-article-item')];
    const showMoreButton = marketingArticleBlock.querySelector('button');

    if (itemsArr.length > showMoreLimit) {
      itemsArr.forEach(item => item.classList.add('marketing-article-item--hidden'));
      itemsArr.slice(0, showMoreLimit).forEach(item => item.classList.remove('marketing-article-item--hidden'));
    }

    showMoreButton.addEventListener('click', () => {
      itemsArr.forEach(item => item.classList.remove('marketing-article-item--hidden'));
      showMoreButton.style.display = 'none';
    });
  })
}

const bootstrapComponents = () => {
  if (document.getElementById("miniCart")) {
    ReactDOM.render(
      <Provider store={store}>
        <MiniCartContainer />
      </Provider>,
      document.getElementById("miniCart")
    );
  }
  if (document.getElementById("quickSearch")) {
    ReactDOM.render(
      <Provider store={store}>
        <QuickSearchContainer />
      </Provider>,
      document.getElementById("quickSearch")
    );
  }
  if (document.getElementById("search")) {
    ReactDOM.render(
      <Provider store={store}>
        <SearchContainer />
      </Provider>,
      document.getElementById("search")
    );
  }

  // if (document.querySelector(".header-notification")) {
  //   const element = document.querySelector(".header-notification");
  //   let notification = {
  //     notificationText: element.dataset.notificationText,
  //     notificationCookieId: element.dataset.notificationCookieId,
  //     notificationWebsiteTheme: element.dataset.notificationWebsiteTheme
  //   };

  //   ReactDOM.render(
  //     <WebsiteSelectNotification { ...{ notification }} />,
  //     element
  //   );
  // }

  if (document.querySelectorAll(".recipe-slider").length > 0) {
    const RecipeListCarousel = DynamicComponent({
      loader: () => import("./Components/RecipeListCarousel"),
    });
    Array.from(document.querySelectorAll(".recipe-slider")).forEach(
      (recipeList, index) => {
        const values = {
          heading: recipeList.dataset.heading,
        };
        const filters = [
          ...recipeList.querySelectorAll(".recipe-slider-filters"),
        ].map((block) => {
          return {
            ...block.dataset,
          };
        });
        const recipes = [
          ...recipeList.querySelectorAll(".recipe-slider-items"),
        ].map((block) => {
          return {
            ...block.dataset,
          };
        });

        if (recipes.length > 0) {
          ReactDOM.render(
            <RecipeListCarousel
              {...values}
              filters={filters}
              recipes={recipes}
            />,
            recipeList
          );
        }
      }
    );
  }
  if (document.querySelectorAll(".product-slider").length > 0) {
    const ProductListSlider = DynamicComponent({
      loader: () => import("./Components/ProductListSlider"),
    });
    Array.from(document.querySelectorAll(".product-slider")).forEach(
      (productList, index) => {
        const values = {
          heading: productList.dataset.heading,
          text: productList.dataset.text,
        };

        const products = [
          ...productList.querySelectorAll(".product-slider-item"),
        ].map((block) => {
          return {
            title: block.dataset.title,
            imageSrc: block.dataset.imagesrc,
            imageAlt: block.dataset.imagealt,
            webTagSrc: block.dataset.webtagsrc,
            linkUrl: block.dataset.linkurl,
            reference: block.dataset.reference,
            usps: block.dataset.usps,
            tags: block.dataset.tags,
            isStockBalanceAboveLimit: block.dataset.isstockbalanceabovelimit == "True" ? true : false,
            showBuyButton: block.dataset.showbuybutton,
            stockStatusDescription: block.dataset.stockstatusdescription,
            actualPrice: block.dataset.actualprice,
            campaignPrice: block.dataset.campaignprice,
            recommendedPrice: block.dataset.recommendedprice,
          };
        });

        const tcProducts = [
          ...productList.querySelectorAll(".product-slider-tc-item"),
        ].map((block) => {
          return {
            productID: block.dataset.productid,
            productName: block.dataset.productname,
            marketingCategory: block.dataset.marketingcategory,
            marketingSubcategory: block.dataset.marketingsubcategory,
            productType: block.dataset.producttype,
            productAvailability: block.dataset.productavailability,
            productPrice: block.dataset.productprice,
            productCurrency: block.dataset.productcurrency,
            productBrand: block.dataset.productbrand,
            productLabel: block.dataset.productlabel,
            position: block.dataset.position,
            productListName: block.dataset.productlistname,
          };
        });

        cleanElementDataAttributes(productList);

        if (products.length > 0) {
          ReactDOM.render(
            <Provider store={store}>
              <ProductListSlider
                {...values}
                products={products}
                tcProducts={tcProducts}
              />
            </Provider>,
            productList
          );
        }
      }
    );
  }

  if (document.getElementById("navbar")) {
    var element = document.getElementById("navbar");
    var isAuthenticated = element.dataset.isAuthenticated === "True";

    ReactDOM.render(
      <Provider store={store}>
        <NavigationContainer {...{ isAuthenticated }} />
      </Provider>,
      element
    );
  }
  if (document.getElementById("facetedSearch")) {
    ReactDOM.render(
      <Provider store={store}>
        <FacetedSearchContainer {...window.facetedSearch} />
      </Provider>,
      document.getElementById("facetedSearch")
    );
  }
  if (document.getElementById("recipeFilter")) {
    ReactDOM.render(
      <Provider store={store}>
        <RecipeFilterContainer {...window.facetedSearch} />
      </Provider>,
      document.getElementById("recipeFilter")
    );
  }
  if (document.getElementById("facetedSearchCompact")) {
    ReactDOM.render(
      <Provider store={store}>
        <FacetedSearchCompactContainer />
      </Provider>,
      document.getElementById("facetedSearchCompact")
    );
  }
  if (document.getElementById("recipeFilterCompact")) {
    ReactDOM.render(
      <Provider store={store}>
        <RecipeFilterCompactContainer {...window.facetedSearch} />
      </Provider>,
      document.getElementById("recipeFilterCompact")
    );
  }
  if (document.getElementById("globalNotification")) {
    ReactDOM.render(
      <Provider store={store}>
        <NotificationContainer />
      </Provider>,
      document.getElementById("globalNotification")
    );
  }
  if (document.getElementById("myPagePersons")) {
    const PersonList = DynamicComponent({
      loader: () => import("./Containers/PersonList.container"),
    });
    ReactDOM.render(
      <Provider store={store}>
        <PersonList />
      </Provider>,
      document.getElementById("myPagePersons")
    );
  }
  if (document.getElementById("myPageAddresses")) {
    const AddressList = DynamicComponent({
      loader: () => import("./Containers/AddressList.container"),
    });
    ReactDOM.render(
      <Provider store={store}>
        <AddressList />
      </Provider>,
      document.getElementById("myPageAddresses")
    );
  }
  if (document.getElementById("checkout")) {
    const Checkout = DynamicComponent({
      loader: () => import("./Components/Checkout/Checkout"),
    });
    ReactDOM.render(
      <Provider store={store}>
        <Checkout />
      </Provider>,
      document.getElementById("checkout")
    );
  }
  if (document.getElementById("lightBoxImages")) {
    const LightboxImages = DynamicComponent({
      loader: () => import("./Containers/LightboxImages.container"),
    });
    const rootElement = document.getElementById("lightBoxImages");
    const images = Array.from(rootElement.querySelectorAll("a")).map((img) => ({
      src: img.dataset.src,
    }));
    const thumbnails = Array.from(rootElement.querySelectorAll("a img")).map(
      (img) => ({ src: img.src })
    );
    ReactDOM.render(
      <Provider store={store}>
        <LightboxImages images={images} thumbnails={thumbnails} />
      </Provider>,
      document.getElementById("lightBoxImages")
    );
  }
  if (document.getElementById("orderReturn")) {
    const OrderReturn = DynamicComponent({
      loader: () => import("./Components/OrderReturn/OrderReturn"),
    });
    const element = document.getElementById("orderReturn");
    const values = {
      returnReasons: JSON.parse(element.dataset.returnReasons),
      orderNumberHelpLink: element.dataset.orderNumberHelpLink,
      orderNumberHelpText: element.dataset.orderNumberHelpText,
      articleNotReturnableLink: element.dataset.articleNotReturnableLink,
      articleNotReturnableText: element.dataset.articleNotReturnableText,
    }

    cleanElementDataAttributes(element);

    ReactDOM.render(
      <Provider store={store}>
        <OrderReturn values={values} />
      </Provider>,
      document.getElementById("orderReturn")
    );
  }

  if (document.querySelectorAll(".slider").length > 0) {
    const Slider = DynamicComponent({
      loader: () => import("./Components/Slider"),
    });
    Array.from(document.querySelectorAll(".slider")).forEach(
      (slider, index) => {
        const values = [...slider.querySelectorAll(".slider__block")].map(
          (block) => {
            return {
              image: block.dataset.image,
              url: block.dataset.url,
              text: decode(block.dataset.text),
            };
          }
        );
        if (values.length > 0) {
          ReactDOM.render(<Slider values={values} />, slider);
        }
      }
    );
  }
  if (document.querySelectorAll(".product-detail__images").length > 0) {
    const ProductImageSlider = DynamicComponent({
      loader: () => import("./Components/ProductImageSlider"),
    });
    Array.from(document.querySelectorAll(".product-detail__images")).forEach(
      (productslider, index) => {
        const values = [
          ...productslider.querySelectorAll(".product-detail__image-container"),
        ].map((block) => {
          return {
            image: block.dataset.image,
            imagealt: block.dataset.imagealt,
          };
        });
        if (values.length > 0) {
          ReactDOM.render(
            <ProductImageSlider values={values} />,
            productslider
          );
        }
      }
    );
  }
  if (document.querySelectorAll(".recipe-detail__images").length > 0) {
    const RecipeSlider = DynamicComponent({
      loader: () => import("./Components/RecipeDetail"),
    });
    Array.from(document.querySelectorAll(".recipe-detail__images")).forEach(
      (recipeslider, index) => {
        const values = [
          ...recipeslider.querySelectorAll(".recipe-detail__image-container"),
        ].map((block) => {
          return {
            tag: block.dataset.tag,
            tagtext: block.dataset.tagtext,
            image: block.dataset.image,
            imagetext: block.dataset.imagetext,
          };
        });
        if (values.length > 0) {
          ReactDOM.render(<RecipeSlider values={values} />, recipeslider);
        }
      }
    );
  }
  if (document.querySelectorAll(".faq").length > 0) {
    const Accordion = DynamicComponent({
      loader: () => import("./Components/Accordion"),
    });
    Array.from(document.querySelectorAll(".faq")).forEach(
      (accordion, index) => {
        let items = [...accordion.querySelectorAll(".faq__block")].map(
          (block) => {
            return {
              title: block.dataset.title,
              text: decode(block.dataset.text),
            };
          }
        );
        let title = accordion.querySelector(".faq__title").dataset.title;
        let description =
          accordion.querySelector(".faq__description").dataset.description;
        let values = { title, description, items };
        if (values) {
          ReactDOM.render(<Accordion values={values} />, accordion);
        }
      }
    );
  }

  if (document.querySelectorAll(".product-pointer__item").length > 0) {
    const ProductPointer = DynamicComponent({
      loader: () => import("./Components/ProductPointer"),
    });
    Array.from(document.querySelectorAll(".product-pointer__item")).forEach(
      (productPointer) => {
        const values = {
          heading: productPointer.dataset.heading,
          subtitle: productPointer.dataset.subtitle,
          text: decode(productPointer.dataset.text),
          image: productPointer.dataset.image,
          imagealt: productPointer.dataset.imagealt,
          mobileimage: productPointer.dataset.mobileimage,
          mobileimagealt: productPointer.dataset.mobileimagealt,
          reference: productPointer.dataset.reference,
          linkUrl: productPointer.dataset.linkurl,
          campaignPrice: productPointer.dataset.campaignprice,
          recommendedPrice: productPointer.dataset.recommendedprice,
          isstockbalanceabovelimit:
            productPointer.dataset.isstockbalanceabovelimit == "True"
              ? true
              : false,
          showbuybutton:
            productPointer.dataset.showbuybutton == "True" ? true : false,
        };

        cleanElementDataAttributes(productPointer);

        ReactDOM.render(
          <Provider store={store}>
            <ProductPointer {...values} />
          </Provider>,
          productPointer
        );
      }
    );
  }

  if (document.querySelectorAll(".video-slider").length > 0) {
    const VideoSlider = DynamicComponent({
      loader: () => import("./Components/VideoSlider"),
    });
    Array.from(document.querySelectorAll(".video-slider__items")).forEach(
      (videoslider, index) => {
        const values = [
          ...videoslider.querySelectorAll(".video-slider__media"),
        ].map((block) => {
          return {
            videoid: block.dataset.video,
            url: block.dataset.url,
            heading: block.dataset.heading,
            text: decode(block.dataset.text),
            link: block.dataset.link,
          };
        });
        if (values.length > 0) {
          ReactDOM.render(<VideoSlider values={values} />, videoslider);
        }
      }
    );
  }

  if (document.querySelectorAll(".image-slider").length > 0) {
    const ImageSlider = DynamicComponent({
      loader: () => import("./Components/ImageSlider"),
    });
    Array.from(document.querySelectorAll(".image-slider__items")).forEach(
      (imageslider, index) => {
        const values = [
          ...imageslider.querySelectorAll(".image-slider__media"),
        ].map((block) => {
          return {
            image: block.dataset.image,
            alt: block.dataset.imageAlt,
            url: block.dataset.url,
            heading: block.dataset.heading,
            text: decode(block.dataset.text),
            link: block.dataset.link,
          };
        });
        if (values.length > 0) {
          ReactDOM.render(<ImageSlider values={values} />, imageslider);
        }
      }
    );
  }

  if (document.querySelectorAll(".banner-slider").length > 0) {
    const BannerSlider = DynamicComponent({
      loader: () => import("./Components/BannerSlider"),
    });
    Array.from(document.querySelectorAll(".banner-slider__items")).forEach(
      (bannerslider, index) => {
        const values = [
          ...bannerslider.querySelectorAll(".banner-slider__media"),
        ].map((block) => {
          return {
            image: block.dataset.image,
            mobileimage: block.dataset.mobileimage,
            mobiileimagealt: block.dataset.mobileimagealt,
            webtagimage: block.dataset.webtagimage,
            webtagimagealt: block.dataset.webtagimagealt,
            alt: block.dataset.imageAlt,
            url: block.dataset.url,
            heading: block.dataset.heading,
            text: decode(block.dataset.text),
            link: block.dataset.link,
            theme: block.dataset.theme,
            ismaintitle: block.dataset.ismaintitle == "True" ? true : false,
            subtitle: decode(block.dataset.subtitle),
            issubtitlebgc: block.dataset.issubtitlebgc == "True" ? true : false,
            copylinktextbutton: block.dataset.copylinktextbutton == "True" ? true : false,
          };
        });
       
        if (values.length > 0) {
          ReactDOM.render(<BannerSlider values={values} />, bannerslider);
        }
      }
    );
  }

  if (document.querySelectorAll(".product-tier").length > 0) {
    const ProductTier = DynamicComponent({
      loader: () => import("./Components/ProductTier"),
    });
    Array.from(document.querySelectorAll(".product-tier__items")).forEach(
      (producttier, index) => {
        const values = [
          ...producttier.querySelectorAll(".product-tier__item"),
        ].map((block) => {
          return {
            url: block.dataset.url,
            modifier: block.dataset.modifier,
            banner: block.dataset.banner,
            image: block.dataset.image,
            lifestyleimage: block.dataset.lifestyleimage,
            title: block.dataset.title,
            usp: block.dataset.usp,
            price: block.dataset.price,
            tag: block.dataset.webtagimage,
            tagtext: block.dataset.webtagtext,
            isinstock: block.dataset.isinstock == "True" ? true : false,
            isstockbalanceabovelimit:
              block.dataset.isstockbalanceabovelimit == "True" ? true : false,
            showbuybutton: block.dataset.showbuybutton == "True" ? true : false,
            addtocartarticlenumber: block.dataset.addtocartarticlenumber,
            reference: block.dataset.reference,
            variant: [...block.querySelectorAll(".product-tier__variants")].map(
              (variant) => {
                return {
                  alt: variant.dataset.varianttext,
                  color: variant.dataset.variantcolor,
                };
              }
            ),
            tcproductclick: block.dataset.tcProductclick,
          };
        });
        if (values.length > 0) {
          ReactDOM.render(
            <Provider store={store}>
              <ProductTier values={values} />
            </Provider>,
            producttier
          );
        }
      }
    );
  }

  /* Dynamically loads cshtml product-card-wrapper partials as a react component */
  if (document.querySelectorAll(".product-list__item").length > 0) {
      const ProductCard = DynamicComponent({
          loader: () => import("./Components/ProductCard"),
      });
        const ArticleCard = DynamicComponent({
          loader: () => import("./Components/ArticleCard"),
      });

      Array.from(document.querySelectorAll(".product-list__item")).forEach(
          (productListItem, index) => {
            if (productListItem.classList.contains("product-list__item--product")) {
              RenderProductCard(productListItem, index);
            }
            else {
              RenderAritcleCard(productListItem);
            }
          }
      );

      function RenderProductCard(productListItem, index) {
          const {
            linkUrl,
            imageSrc,
            webTagSrc,
            title,
            usps,
            recommendedPrice,
            actualPrice,
            campaignPrice,
            isInStock,
            isStockBalanceAboveLimit,
            stockStatusDescription,
            showBuyButton,
            addToCartArticleNumber,
            reference,
            listTitle,
            tcProduct
          } = productListItem.dataset;

          let { tags } = productListItem.dataset;

          if (tags) {
              tags = JSON.parse(tags);
          }

          const product = {
              linkUrl,
              imageSrc,
              webTagSrc,
              title,
              recommendedPrice,
              actualPrice,
              campaignPrice,
              usps,
              tags,
              isInStock,
              isStockBalanceAboveLimit:
                isStockBalanceAboveLimit == "True" ? true : false,
              stockStatusDescription,
              showBuyButton: showBuyButton == "True" ? true : false,
              addToCartArticleNumber,
              reference,
          };

          cleanElementDataAttributes(productListItem);

          ReactDOM.render(
              <Provider store={store}>
                  <ProductCard {...{ product }} onClick={() => tcEventProductClickEvent(tcProduct, listTitle, index)} />
              </Provider>,
              productListItem
          );
      }

      function RenderAritcleCard(articleListItem) {
        const { title, text, theme, imageSrc, webTagSrc, linkUrl, linkText } = articleListItem.dataset;

        cleanElementDataAttributes(articleListItem);

        ReactDOM.render(
            <Provider store={store}>
                <ArticleCard {...{ title, text, theme, imageSrc, webTagSrc, linkUrl, linkText }} />
            </Provider>,
            articleListItem
        );
      }
  }

  if (document.querySelectorAll(".product-list--featured").length > 0) {
    const ProductListFeatured = DynamicComponent({
      loader: () => import("./Components/ProductListFeatured"),
    });
    Array.from(
      document.querySelectorAll(".product-list--featured .product-list__items")
    ).forEach((productlist, index) => {
      const values = [
        ...productlist.querySelectorAll(".product-list__item"),
      ].map((block) => {
        return {
          modifier: block.dataset.modifier,
          image: block.dataset.image,
          lifestyleimage: block.dataset.lifestyleimage,
          title: block.dataset.title,
          usp: block.dataset.usp,
          price: block.dataset.price,
          url: block.dataset.url,
          tag: block.dataset.webtagimage,
          tagtext: block.dataset.webtagtext,
          variant: [...block.querySelectorAll(".product-list__variants")].map(
            (variant) => {
              return {
                alt: variant.dataset.varianttext,
                color: variant.dataset.variantcolor,
              };
            }
          ),
          tcproductclick: block.dataset.tcProductclick,
        };
      });
      if (values.length > 0) {
        ReactDOM.render(<ProductListFeatured values={values} />, productlist);
      }
    });
  }

  if (document.querySelectorAll(".product-list--category").length > 0) {
    const CategoryProductList = DynamicComponent({
      loader: () => import("./Components/CategoryProductList"),
    });

    Array.from(document.querySelectorAll(".product-list--category")).forEach(
      (categoryProductList) => {
        const {
          categorysystemid,
          blocksystemid,
          title,
          sortoptions,
          ismaintitle,
          numberofproducts,
        } = categoryProductList.dataset;

        cleanElementDataAttributes(categoryProductList);
        
        ReactDOM.render(
          <Provider store={store}>
            <CategoryProductList
              {...{
                categorySystemId: categorysystemid,
                blockSystemId: blocksystemid,
                title,
                sortOptions: sortoptions,
                isMainTitle: ismaintitle == "True" ? true : false,
                numberOfProducts: numberofproducts,
              }}
            />
          </Provider>,
          categoryProductList
        );
      }
    );
  }

  if (document.querySelectorAll("buy-button").length > 0) {
    const BuyButton = DynamicComponent({
      loader: () => import("./Containers/BuyButton.container"),
    });
    Array.from(document.querySelectorAll("buy-button")).forEach((button) => {
      const { articleNumber, href, cssClass } = button.dataset;
      const label = button.innerText;
      ReactDOM.render(
        <Provider store={store}>
          <BuyButton {...{ label, articleNumber, href, cssClass }} />
        </Provider>,
        button
      );
    });
  }

  if (document.querySelectorAll("reorder-button").length > 0) {
    const ReorderButton = DynamicComponent({
      loader: () => import("./Containers/ReorderButton.Container"),
    });
    Array.from(document.querySelectorAll("reorder-button")).forEach(
      (button) => {
        const { cssClass, orderId, title } = button.dataset;
        const label = button.innerText;
        ReactDOM.render(
          <Provider store={store}>
            <ReorderButton {...{ label, title, cssClass, orderId }} />
          </Provider>,
          button
        );
      }
    );
  }

  if (document.getElementById("anchor-link")) {
    const SmoothScroll = DynamicComponent({
      loader: () => import("./Components/AnchorLink"),
    });
    const text = document.getElementById("anchor-link").dataset.text;
    const href = document.getElementById("anchor-link").dataset.href;
    const values = { text, href };
    ReactDOM.render(
      <Provider store={store}>
        <SmoothScroll values={values} />
      </Provider>,
      document.getElementById("anchor-link")
    );
  }

  if (document.querySelectorAll(".tab__accordion-header").length > 0) {
    if (window.innerWidth < mobileBreakpoint) {
      var tabHeaders = document.getElementsByClassName("tab__accordion-header");

      [...tabHeaders].forEach((header) => {
        header.addEventListener("click", (e) => {
          var content = header.nextElementSibling;
          content.classList.toggle("tab__toggle-tab-content");
          var icon = header.querySelector("#tab__icon-order-tab");
          if (icon.innerHTML === "add") {
            icon.innerHTML = "remove";
          } else {
            icon.innerHTML = "add";
          }
        });
      });
    }
  }

  if (document.querySelectorAll(".accordion__header").length > 0) {
    const accordionHeaders = document.querySelectorAll(".accordion__header");

    [...accordionHeaders].forEach((header) => {
      const content = header.nextElementSibling;
      const breakpoint = header.dataset.breakpoint;

      function accordionToggle() {
        header.classList.toggle("active");
        content.classList.toggle("active");
      }

      function handleResize() {
        if (window.innerWidth > breakpoint) {
          content.classList.add("active");
          header.classList.add("active");
          header.removeEventListener("click", accordionToggle);
        } else {
          content.classList.remove("active");
          header.classList.remove("active");
          header.addEventListener("click", accordionToggle);
        }
      }

      if (breakpoint) {
        window.addEventListener("resize", handleResize);

        if (window.innerWidth < breakpoint)
          header.addEventListener("click", accordionToggle);
        else content.classList.add("active");

        handleResize(); // Initial check
      } else header.addEventListener("click", accordionToggle);
    });
  }

  if (document.querySelectorAll(".brandtag--designinggoodlife").length > 0) {
    const DesigningGoodLife = DynamicComponent({
      loader: () => import("./Components/BrandTags/DesigningGoodLife"),
    });

    Array.from(document.querySelectorAll(".brandtag--designinggoodlife")).forEach(brandtag => {
      ReactDOM.render(
        <DesigningGoodLife />,
        brandtag
      )
    });
  }

  const tabMyPages = document.querySelector(".tab-my-pages");

  if (tabMyPages) {
    const toggleElements = tabMyPages.querySelectorAll('.tab-my-pages__header');
  
    toggleElements.forEach((el) => {
      el.addEventListener('click', () => {
        el.nextElementSibling.classList.toggle('tab-my-pages__content--visible');
        const icon = el.querySelector(".material-icons");
        icon.innerHTML = icon.innerHTML === 'add' ? 'remove' : 'add';
      });
    });
  }

  if (document.querySelectorAll("[data-dialog]").length > 0) {
    /*
            Structure - a root dialog element is needed with data-dialog attribute set.
            The dialog also need to have a data-dialog-toggle attribute set with a value that corresponds to the toggle-button dataset, for instance:
            <dialog data-dialog-toggle="my-dialog-toggle"> needs a <button my-dialog-toggle> set - in order to have them connected.
        */
    Array.from(document.querySelectorAll("[data-dialog]")).forEach((dialog) => {
      const dialogBackdrop = dialog.querySelector("[data-dialog-backdrop]");
      const dialogCloseIcon = dialog.querySelector("[data-dialog-close]");
      const dialogAnimationDuration = 0.3;
      const html = document.querySelector("html");

      dialog.style.setProperty(
        "--animation-duration",
        `${dialogAnimationDuration}s`
      ); // Set css property to sync animation duration with timeout duration
      dialog.addEventListener(
        "click",
        (e) => {
          if (e.target == dialogBackdrop) closeDialog(); // Close on backdrop click
          if (
            e.target == dialogCloseIcon ||
            e.target.parentElement == dialogCloseIcon
          )
            closeDialog(); // Close on close button click
        },
        true
      );

      document.addEventListener("click", (e) => {
        /* Special solution, we can not directly access elements with data-dialog-toggle set, since it may be rendered in react, for instance, in the checkout. Because of this we must allow every element ot load, hence checking afterwards for the data attribute */
        const buttonTarget = e.target.closest("button");
        if (buttonTarget == null) return;
        if (buttonTarget.dataset == null) return;

        /* Globally check each click if we are clicking on one of the designated data-dialog-toggle element */
        if (buttonTarget.hasAttribute(dialog.dataset.dialogToggle)) {
          const isOpen = dialog.hasAttribute("open");
          isOpen ? closeDialog(e) : openDialog(e);
        }
      });

      function closeDialog(e) {
        dialog.classList.add("is-closing");
        html.classList.remove("no-scroll");
        const video = dialog.querySelector("video");
        if(video) {
          video.pause();
        }
        setTimeout(() => {
          dialog.removeAttribute("open");
          dialog.classList.remove("is-closing");
        }, dialogAnimationDuration * 1000);
      }

      function openDialog(e) {
        dialog.setAttribute("open", true);
        html.classList.add("no-scroll");
        const video = dialog.querySelector("video");
        if(video) {
          video.play();
        }
      }
    });
  }

  if (document.querySelectorAll(".wheel-product-slider").length > 0) {
    const WheelProductSlider = DynamicComponent({
      loader: () => import("./Components/WheelProductSlider"),
    });
    Array.from(document.querySelectorAll(".wheel-product-slider")).forEach(
      (wheelProductSlider) => {
        const {
          wheelbaseclass,
          title,
          text,
          linktext,
          theme,
          image,
          imagetopleft,
          imagetopright,
          knobtext,
          productlistsjson,
        } = wheelProductSlider.dataset;

        cleanElementDataAttributes(wheelProductSlider);

        ReactDOM.render(
          <Provider store={store}>
            <WheelProductSlider
              {...{
                wheelBaseClass: wheelbaseclass,
                title,
                text,
                linkText: linktext,
                theme,
                image,
                knobtext,
                imageTopLeft: imagetopleft,
                imageTopRight: imagetopright,
                productlists: JSON.parse(productlistsjson),
              }}
            />
          </Provider>,
          wheelProductSlider
        );
      }
    );
  }

  if (document.querySelectorAll(".newsletter-block")) {
    const NewsletterBlock = DynamicComponent({
      loader: () => import("./Components/Newsletter"),
    });
    Array.from(document.querySelectorAll(".newsletter-block")).forEach(
      (newsletterBlock) => {
        const { title, preamble, list, emailInputLabel, emailInputPlaceholder, acceptanceText, submitText, submitResult } = newsletterBlock.dataset;
        cleanElementDataAttributes(newsletterBlock);
        ReactDOM.render(
          <Provider store={store}>
            <NewsletterBlock {...{ title, preamble, list, emailInputLabel, emailInputPlaceholder, acceptanceText, submitText, submitResult }} />
          </Provider>,
          newsletterBlock
        );
      }
    );
  }

  if (document.querySelectorAll(".image-hotspot-block")) {
    const ImageHotspotBlock = DynamicComponent({
      loader: () => import("./Components/ImageHotspot"),
    });
    Array.from(document.querySelectorAll(".image-hotspot-block")).forEach(
      (imageHotspotBlock) => {
        const { title, preamble, properties, imageSrc, imageMobileSrc, hotspots, linkUrl, linkText, usps } = imageHotspotBlock.dataset;
        cleanElementDataAttributes(imageHotspotBlock);
        ReactDOM.render(
          <Provider store={store}>
            <ImageHotspotBlock {...{ title, preamble, properties, imageSrc, imageMobileSrc, hotspots, linkUrl, linkText, usps }} />
          </Provider>,
          imageHotspotBlock
        );
      }
    );
  }

  if (document.querySelectorAll("[data-selectbox]")) {
    const Selectbox = DynamicComponent({
      loader: () => import("./Components/Selectbox"),
    });

    Array.from(document.querySelectorAll("[data-selectbox]")).forEach(selectbox => {
      const options = [...selectbox.children].map(option => {
        return {
          value: option.value,
          label: option.textContent,
          selected: option.selected
        }
      })

      ReactDOM.render(
        <Provider store={store}>
          <Selectbox 
            placeHolder={selectbox.dataset.placeholder}
            options={options}
            isMulti={false}
            isSearchable={false}
            onChange={selectbox.onchange}
            align="right"
          />

        </Provider>,
        selectbox.parentElement
      );

      selectbox.remove();
    })
  };

  if (document.querySelector("[data-product-description]")) {
    const elem = document.querySelector("[data-product-description]");
    const elemShowMore = elem.querySelector("button");
    if (!elemShowMore) return;

    elemShowMore.addEventListener(
      "click",
      (e) => {
        const elemContent = elem.querySelector("[data-text]");
        const expandedData = elemContent.dataset.text;

        if (!expandedData) return;

        elem.dataset.expanded = true;
        elemContent.dataset.text = "";
        elemContent.innerHTML = expandedData;
        elemShowMore.remove();
      },
      { once: true }
    );
  }
};

const bootstrapSearchResultFilterProductList = () => {
  /* Dynamically re-renders the search result filter product list components */
  if (document.querySelectorAll("#search-result .product-list__item").length > 0) {
      const ProductCard = DynamicComponent({
          loader: () => import("./Components/ProductCard"),
      });
      Array.from(document.querySelectorAll("#search-result .product-list__item")).forEach(
          (productListItem, index) => {
              const {
                  linkurl,
                  imagesrc,
                  webtagsrc,
                  title,
                  usps,
                  tags,
                  recommendedprice,
                  actualprice,
                  campaignprice,
                  isinstock,
                  isstockbalanceabovelimit,
                  stockstatusdescription,
                  showbuybutton,
                  addtocartarticlenumber,
                  reference,
              } = productListItem.dataset;

              const product = {
                  linkUrl: linkurl,
                  imageSrc: imagesrc,
                  webTagSrc: webtagsrc,
                  title,
                  recommendedPrice: recommendedprice,
                  actualPrice: actualprice,
                  campaignPrice: campaignprice,
                  usps,
                  tags,
                  isInStock: isinstock,
                  isStockBalanceAboveLimit:
                      isstockbalanceabovelimit == "True" ? true : false,
                  stockStatusDescription: stockstatusdescription,
                  showBuyButton: showbuybutton == "True" ? true : false,
                  addToCartArticleNumber: addtocartarticlenumber,
                  reference,
              };

              cleanElementDataAttributes(productListItem);

              ReactDOM.render(
                  <Provider store={store}>
                      <ProductCard {...{ product }} />
                  </Provider>,
                  productListItem
              );
          }
      );
  }

  if (document.querySelectorAll("#search-result [data-selectbox]")) {
    const Selectbox = DynamicComponent({
      loader: () => import("./Components/Selectbox"),
    });

    Array.from(document.querySelectorAll("#search-result [data-selectbox]")).forEach(selectbox => {
      const options = [...selectbox.children].map(option => {
        return {
          value: option.value,
          label: option.textContent,
          selected: option.selected
        }
      })

      ReactDOM.render(
        <Provider store={store}>
          <Selectbox 
            placeHolder={selectbox.dataset.placeholder}
            options={options}
            isMulti={false}
            isSearchable={false}
            onChange={selectbox.onchange}
            align="right"
          />

        </Provider>,
        selectbox.parentElement
      );

      selectbox.remove();
    })
  };
};

// Function to handle copying logic
const handleCopy = async (copyable) => {
  try {
      let copyText = copyable.innerText.trim();

      await navigator.clipboard.writeText(copyText);

      copyable.removeAttribute('data-copyable-hide');
      copyable.setAttribute('data-copyable-success', true);

      setTimeout(() => {
          copyable.removeAttribute('data-copyable-success');
          copyable.setAttribute('data-copyable-hide', true);
      }, 2000);
  } catch (err) {
      console.error('Failed to copy: ', err);
  }
};

// Function to initialize copyable elements
const initializeCopyables = (copyables) => {
  copyables.forEach((copyable) => {
      const copyText = translate('copy');
      const copySuccessText = translate('copy.success');

      copyable.setAttribute('data-copyable', copySuccessText);
      copyable.setAttribute('aria-label', copyText);
      copyable.setAttribute('title', copyText);

      copyable.addEventListener('click', (e) => {
          e.stopPropagation();
          handleCopy(copyable);
      });
  });
};

const initializeNotification = (notifications) => {
  notifications.forEach((notification) => {
    const showNotificationDelayMS = 1000
    const cookieId = notification.dataset.cookieid
    const notificationCookieName = `notification-${cookieId}-hide`
    const closeBtn = notification.querySelector("button")
    const show = () => notification.removeAttribute("hidden")
    const hide = () => {
      setCookie(notificationCookieName, true, 1)
      notification.setAttribute("hidden", "")
    }

    closeBtn.addEventListener("click", () => hide())
            
    if (getCookie(notificationCookieName) == false) {
      setTimeout(() => show(), showNotificationDelayMS)
    }
  });
};

// Observe changes to the DOM
const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Check if new elements with data-copyable attribute are added
      if (document.querySelectorAll('[data-copyable]')) {
          initializeCopyables(document.querySelectorAll('[data-copyable]'))
      }

      if (document.querySelectorAll("[data-notification]")) {
        initializeNotification(document.querySelectorAll("[data-notification]"))
      }
    }
  }
});

// Start observing the DOM for changes
observer.observe(document.body, { childList: true, subtree: true });

// Initial setup for existing copyable elements
const initialCopyables = document.querySelectorAll('[data-copyable]');
initializeCopyables(initialCopyables);


function cleanElementDataAttributes(element) {
  // Remove all data-* attributes
  Array.from(element.attributes).forEach((attribute) => {
    if (attribute.name.startsWith("data-")) {
      element.removeAttribute(attribute.name);
    }
  }, 0);
}

bootstrapComponents();